import * as vp from 'vopay';

import { FunctionComponent, useContext, useMemo } from 'react';
import TicketCreationContext from './TicketCreationContext';

import { DialogueHandler, TicketCreationDialogueHandlers } from '../types';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type LeadCreationDialogueProps = {
  handleDialogue: DialogueHandler<TicketCreationDialogueHandlers>;
};

type FC = FunctionComponent<LeadCreationDialogueProps>;

const TicketCreationDialogue: FC = ({ handleDialogue }: LeadCreationDialogueProps) => {
  const { showCreateTicketSuccessAlert, showCreateTicketErrorAlert, createTicketError } =
    useContext(TicketCreationContext);
  const { t } = useTranslation('translations', { keyPrefix: 'Tickets.Create.Dialog' });

  return useMemo(
    () => (
      <div>
        {/* Delete User Error */}

        <ConfirmationDialogue
          isVisible={showCreateTicketErrorAlert}
          title={t('TicketCreationError.title')}
          status="error"
          subTitle={`${createTicketError}`}
          confirm={{
            label: t('TicketCreationError.confirmButton'),
            action: () => handleDialogue({ type: 'create', state: 'fail' }),
          }}
        />

        {/* Delete User Success */}

        <ConfirmationDialogue
          isVisible={showCreateTicketSuccessAlert}
          status="success"
          title={t('TicketCreationSuccess.title')}
          subTitle={t('TicketCreationSuccess.subTitle')}
          confirm={{
            label: t('TicketCreationSuccess.confirmButton'),
            action: () => handleDialogue({ type: 'create', state: 'success' }),
          }}
        />
      </div>
    ),
    [showCreateTicketSuccessAlert, showCreateTicketErrorAlert],
  );
};

export default TicketCreationDialogue;
